import React, { createContext, Component, PureComponent } from 'react';
import 'prop-types';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DocumentsContext = createContext(null);

var Documents =
/*#__PURE__*/
function (_Component) {
  _inherits(Documents, _Component);

  function Documents() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Documents);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Documents)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      documents: {}
    });

    _defineProperty(_assertThisInitialized(_this), "setDocument", function (id, pdf) {
      var documents = _this.state.documents;
      var document = documents[id];

      if (document && !document.loading) {
        return;
      }

      _this.setState(function (state) {
        return _objectSpread({}, state, {
          documents: _objectSpread({}, state.documents, _defineProperty({}, id, {
            loading: false,
            pdf: pdf
          }))
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFailedDocument", function (id) {
      _this.setState(function (state) {
        return _objectSpread({}, state, {
          documents: _objectSpread({}, state.documents, _defineProperty({}, id, {
            loading: false,
            failed: true
          }))
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setLoadDocument", function (id) {
      _this.setState(function (state) {
        return _objectSpread({}, state, {
          documents: _objectSpread({}, state.documents, _defineProperty({}, id, {
            loading: true
          }))
        });
      });
    });

    return _this;
  }

  _createClass(Documents, [{
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.props.children;
      return React.createElement(DocumentsContext.Provider, {
        value: this.childContext
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderChildren();
    }
  }, {
    key: "childContext",
    get: function get() {
      var documents = this.state.documents;
      return {
        documents: documents,
        setDocument: this.setDocument,
        setLoadDocument: this.setLoadDocument,
        setFailedDocument: this.setFailedDocument
      };
    }
  }]);

  return Documents;
}(Component);

var DocumentContext = createContext(null);

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var DocumentInternal =
/*#__PURE__*/
function (_Component) {
  _inherits(DocumentInternal, _Component);

  function DocumentInternal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DocumentInternal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DocumentInternal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handlerSourceSuccess", function () {
      var onSourceSuccess = _this.props.onSourceSuccess;
      onSourceSuccess();
    });

    _defineProperty(_assertThisInitialized(_this), "handlerSourceError", function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      var onSourceError = _this.props.onSourceError;
      onSourceError(error);
    });

    _defineProperty(_assertThisInitialized(_this), "handlerLoadSuccess", function (id, pdf) {
      var onLoadSuccess = _this.props.onLoadSuccess;
      onLoadSuccess(id, pdf);
    });

    _defineProperty(_assertThisInitialized(_this), "handlerLoadError", function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      var onLoadError = _this.props.onLoadError;
      onLoadError(error);
    });

    _defineProperty(_assertThisInitialized(_this), "loadDocument", _async(function () {
      var _this$props = _this.props,
          url = _this$props.url,
          id = _this$props.id,
          documents = _this$props.documents,
          setLoadDocument = _this$props.setLoadDocument;
      var document = documents[id];

      if (document && document.loading) {
        return;
      }

      if (url) {
        _this.handlerSourceSuccess();
      } else {
        _this.handlerSourceError(new Error('Source error'));

        return;
      }

      var _this$props2 = _this.props,
          onLoadProgress = _this$props2.onLoadProgress,
          setDocument = _this$props2.setDocument,
          setFailedDocument = _this$props2.setFailedDocument;
      return _catch(function () {
        setLoadDocument(id);

        if (typeof PDFJS === 'undefined') {
          throw new Error('PDFJS is undefined');
        }

        var loadingTask = PDFJS.getDocument(url);

        if (onLoadProgress) {
          loadingTask.onProgress = onLoadProgress;
        }

        _this.runningTask = loadingTask;
        return _await(_this.runningTask, function (pdf) {
          setDocument(id, pdf);

          _this.handlerLoadSuccess(id, pdf);
        });
      }, function (error) {
        setFailedDocument(id);

        _this.handlerLoadError(error);
      });
    }));

    return _this;
  }

  _createClass(DocumentInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          documents = _this$props3.documents,
          autoload = _this$props3.autoload;
      var document = documents[id];

      if (autoload && !document) {
        this.loadDocument();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          documents = _this$props4.documents,
          autoload = _this$props4.autoload;
      var document = documents[id];

      if (autoload && !document) {
        this.loadDocument();
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (this.status === DocumentInternal.statuses.NO_DATA) {
        var cmpNoData = this.props.cmpNoData;
        return cmpNoData;
      }

      if (this.status === DocumentInternal.statuses.FAILED) {
        var cmpError = this.props.cmpError;
        return cmpError;
      }

      if (this.status === DocumentInternal.statuses.LOADING) {
        var cmpLoading = this.props.cmpLoading;
        return cmpLoading;
      }

      return this.renderChildren();
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.props.children;
      return React.createElement(DocumentContext.Provider, {
        value: this.childContext
      }, children);
    }
  }, {
    key: "renderFunction",
    value: function renderFunction() {
      var children = this.props.children;
      return React.createElement(DocumentContext.Provider, {
        value: this.childContext
      }, children(this.status));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? this.renderFunction() : this.renderContent();
    }
  }, {
    key: "childContext",
    get: function get() {
      var _this$props5 = this.props,
          id = _this$props5.id,
          documents = _this$props5.documents,
          rotate = _this$props5.rotate,
          scale = _this$props5.scale;
      var document = documents[id];
      var pdf = document && document.pdf;
      return {
        pdf: pdf,
        rotate: rotate,
        scale: scale
      };
    }
  }, {
    key: "status",
    get: function get() {
      var _this$props6 = this.props,
          id = _this$props6.id,
          documents = _this$props6.documents;
      var document = documents[id];

      if (!id || !document) {
        return DocumentInternal.statuses.NO_DATA;
      }

      if (document.failed) {
        return DocumentInternal.statuses.FAILED;
      }

      if (document.loading) {
        return DocumentInternal.statuses.LOADING;
      }

      return DocumentInternal.statuses.READY;
    }
    /**
     * Called when a document source is resolved correctly
     */

  }]);

  return DocumentInternal;
}(Component);

_defineProperty(DocumentInternal, "displayName", 'Document');

_defineProperty(DocumentInternal, "statuses", {
  NO_DATA: 'noData',
  LOADING: 'loading',
  FAILED: 'failed',
  READY: 'ready'
});

_defineProperty(DocumentInternal, "defaultProps", {
  children: null,
  rotate: null,
  scale: null,
  cmpError: 'document error',
  cmpLoading: 'document loading',
  cmpNoData: 'document noData',
  autoload: true,
  onLoadError: function onLoadError() {},
  onLoadProgress: function onLoadProgress() {},
  onLoadSuccess: function onLoadSuccess() {},
  onSourceError: function onSourceError() {},
  onSourceSuccess: function onSourceSuccess() {},
  setDocument: function setDocument() {},
  setFailedDocument: function setFailedDocument() {},
  setLoadDocument: function setLoadDocument() {}
});

var Document = function Document(props) {
  return React.createElement(DocumentsContext.Consumer, null, function (context) {
    return React.createElement(DocumentInternal, _extends({}, props, context));
  });
};

Document.statuses = DocumentInternal.statuses;

var PageContext = createContext(null);

var PageCanvasInternal =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PageCanvasInternal, _PureComponent);

  function PageCanvasInternal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PageCanvasInternal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PageCanvasInternal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onRenderSuccess", function () {
      _this.renderer = null;

      var _assertThisInitialize = _assertThisInitialized(_this),
          renderViewport = _assertThisInitialize.renderViewport,
          canvasLayer = _assertThisInitialize.canvasLayer;

      var _this$props = _this.props,
          onRenderSuccess = _this$props.onRenderSuccess,
          scale = _this$props.scale;
      onRenderSuccess(renderViewport.width, renderViewport.height, canvasLayer, scale);
    });

    _defineProperty(_assertThisInitialized(_this), "onRenderError", function (error) {
      var onRenderError = _this.props.onRenderError;
      onRenderError(error);
    });

    _defineProperty(_assertThisInitialized(_this), "drawPageOnCanvas", function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          canvas = _assertThisInitialize2.canvasLayer;

      if (!canvas) {
        return null;
      }

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          renderViewport = _assertThisInitialize3.renderViewport;

      var page = _this.props.page;
      canvas.width = renderViewport.width;
      canvas.height = renderViewport.height;
      var renderContext = {
        get canvasContext() {
          return canvas.getContext('2d');
        },

        viewport: renderViewport
      }; // If another render is in progress, let's cancel it

      _this.cancelRenderingTask();

      _this.renderer = page.render(renderContext);
      return _this.renderer.then(_this.onRenderSuccess)["catch"](_this.onRenderError);
    });

    return _this;
  }

  _createClass(PageCanvasInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawPageOnCanvas();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          page = _this$props2.page,
          zoom = _this$props2.zoom;

      if (prevProps.zoom !== zoom) {
        page.cleanup();
        this.drawPageOnCanvas();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRenderingTask();
    }
    /**
     * Called when a page is rendered successfully.
     */

  }, {
    key: "cancelRenderingTask",
    value: function cancelRenderingTask() {
      /* eslint-disable no-underscore-dangle */
      if (this.renderer && this.renderer._internalRenderTask.running) {
        this.renderer._internalRenderTask.cancel();
      }
      /* eslint-enable no-underscore-dangle */

    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          inlineStyles = _this$props3.inlineStyles;
      return React.createElement("canvas", {
        className: className,
        style: inlineStyles,
        ref: function ref(_ref) {
          _this2.canvasLayer = _ref;
        }
      });
    }
  }, {
    key: "renderViewport",
    get: function get() {
      var _this$props4 = this.props,
          page = _this$props4.page,
          rotate = _this$props4.rotate,
          scale = _this$props4.scale,
          zoom = _this$props4.zoom;
      return page.getViewport(scale * zoom, rotate);
    }
  }, {
    key: "viewport",
    get: function get() {
      var _this$props5 = this.props,
          page = _this$props5.page,
          rotate = _this$props5.rotate,
          scale = _this$props5.scale;
      return page.getViewport(scale, rotate);
    }
  }]);

  return PageCanvasInternal;
}(PureComponent);

_defineProperty(PageCanvasInternal, "defaultProps", {
  className: '',
  rotate: false,
  inlineStyles: {},
  zoom: 1,
  onRenderError: function onRenderError() {},
  onRenderSuccess: function onRenderSuccess() {}
});

var PageCanvas = function PageCanvas(props) {
  return React.createElement(PageContext.Consumer, null, function (context) {
    return React.createElement(PageCanvasInternal, _extends({}, context, props));
  });
};

function _await$1(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var defaultScale = 1;

function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _empty() {}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _async$1(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var PageInternal =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PageInternal, _PureComponent);

  function PageInternal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PageInternal);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PageInternal)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      page: null,
      error: false,
      rendered: false
    });

    _defineProperty(_assertThisInitialized(_this), "loadPage", _async$1(function () {
      var pdf = _this.props.pdf;

      var pageNumber = _this.getPageNumber();

      if (!pageNumber) {
        return;
      }

      _this.setState(function (prevState) {
        if (!prevState.page) {
          return null;
        }

        return {
          page: null
        };
      });

      return _continueIgnored(_catch$1(function () {
        _this.runningTask = pdf.getPage(pageNumber);
        return _await$1(_this.runningTask, function (page) {
          _this.setState({
            page: page,
            error: false
          }, _this.handlerLoadSuccess);
        });
      }, function (error) {
        _this.setState({
          error: true
        });

        _this.handlerLoadError(error);
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "handlerLoadSuccess", function () {
      var onLoadSuccess = _this.props.onLoadSuccess;
      var page = _this.state.page;
      onLoadSuccess(page);
    });

    _defineProperty(_assertThisInitialized(_this), "handlerLoadError", function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      var onLoadError = _this.props.onLoadError;
      onLoadError(error);
    });

    _defineProperty(_assertThisInitialized(_this), "handlerRenderSuccess", function () {
      var onRenderSuccess = _this.props.onRenderSuccess;

      _this.setState({
        rendered: true
      });

      onRenderSuccess.apply(void 0, arguments);
    });

    return _this;
  }

  _createClass(PageInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pdf = this.props.pdf;

      if (!pdf) {
        throw new Error('Attempted to load a page, but no document was specified.');
      }

      this.loadPage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pdf = this.props.pdf;

      if (prevProps.pdf && pdf !== prevProps.pdf || this.getPageNumber() !== this.getPageNumber(prevProps)) {
        this.loadPage();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.runningTask || !this.runningTask.cancel) {
        return;
      }

      this.runningTask.cancel();
    }
  }, {
    key: "getPageNumber",
    value: function getPageNumber() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (props.pageNumber != null) {
        return props.pageNumber;
      }

      if (props.pageIndex != null) {
        return props.pageIndex + 1;
      }

      return null;
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (props.pageNumber != null) {
        return props.pageNumber - 1;
      }

      if (props.pageIndex != null) {
        return props.pageIndex;
      }

      return null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var pageNumber = this.pageNumber;
      var pdf = this.props.pdf;
      var _this$state = this.state,
          page = _this$state.page,
          pageError = _this$state.error;

      if (!pageNumber) {
        var cmpNoData = this.props.cmpNoData;
        return cmpNoData;
      }

      if (!pageError && (!page || !pdf)) {
        var cmpLoading = this.props.cmpLoading;
        return cmpLoading;
      }

      if (pageError) {
        var cmpError = this.props.cmpError;
        return cmpError;
      }

      return this.renderChildren();
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props = this.props,
          children = _this$props.children,
          cmpRendered = _this$props.cmpRendered;
      var rendered = this.state.rendered;
      return React.createElement(PageContext.Provider, {
        value: this.childContext
      }, React.createElement(PageCanvas, null), !rendered && cmpRendered, children);
    }
  }, {
    key: "render",
    value: function render() {
      var pageNumber = this.pageNumber;
      var className = this.props.className;
      return React.createElement("div", {
        className: className,
        "data-page-number": pageNumber
      }, this.renderContent());
    }
  }, {
    key: "childContext",
    get: function get() {
      var page = this.state.page;

      if (!page) {
        return {};
      }

      var _this$props2 = this.props,
          zoom = _this$props2.zoom,
          className = _this$props2.canvasClassName,
          onRenderError = _this$props2.onRenderError;
      return {
        page: page,
        zoom: zoom,
        scale: this.scale,
        rotate: this.rotate,
        className: className,
        onRenderError: onRenderError,
        onRenderSuccess: this.handlerRenderSuccess
      };
    }
  }, {
    key: "pageNumber",
    get: function get() {
      return this.getPageNumber();
    }
  }, {
    key: "pageIndex",
    get: function get() {
      return this.getPageIndex();
    }
  }, {
    key: "rotate",
    get: function get() {
      var rotate = this.props.rotate;

      if (rotate != null) {
        return rotate;
      }

      var page = this.state.page;
      var pageInfo = page.pageInfo;

      if (!page) {
        return null;
      }

      return pageInfo.rotate;
    }
  }, {
    key: "scale",
    get: function get() {
      var page = this.state.page;

      if (!page) {
        return null;
      }

      var _this$props3 = this.props,
          scale = _this$props3.scale,
          width = _this$props3.width,
          height = _this$props3.height;
      var rotate = this.rotate; // Be default, we'll render page at 100% * scale width.

      var pageScale = 1; // Passing scale explicitly null would cause the page not to render

      var scaleWithDefault = scale === null ? defaultScale : scale; // If width/height is defined, calculate the scale of the page so it could be of desired width.

      if (width || height) {
        var viewport = page.getViewport(scaleWithDefault, rotate);
        var isLandscape = viewport.width > viewport.height;

        if (isLandscape) {
          pageScale = height ? height / viewport.width : width / viewport.height;
        } else {
          pageScale = width ? width / viewport.height : height / viewport.width;
        }
      }

      return scaleWithDefault * pageScale;
    }
  }]);

  return PageInternal;
}(PureComponent);

_defineProperty(PageInternal, "displayName", 'Page');

_defineProperty(PageInternal, "defaultProps", {
  className: null,
  canvasClassName: null,
  cmpError: null,
  cmpLoading: null,
  cmpNoData: null,
  cmpRendered: null,
  scale: defaultScale,
  rotate: null,
  width: null,
  height: null,
  children: null,
  pageIndex: 0,
  pageNumber: 1,
  pdf: false,
  zoom: 1,
  onLoadError: function onLoadError() {},
  onLoadSuccess: function onLoadSuccess() {},
  onRenderError: function onRenderError() {},
  onRenderSuccess: function onRenderSuccess() {}
});

var Page = function Page(props) {
  return React.createElement(DocumentContext.Consumer, null, function (context) {
    return React.createElement(PageInternal, _extends({}, context, props));
  });
};

export { Document, DocumentContext, Documents, DocumentsContext, Page };
